import { useQueryClient } from "react-query";
import React, { Suspense, useEffect, useMemo } from "react";
import { Button, Empty, Result, Spin, Typography } from "antd";
import { MainTemplateLoading } from "./MainTemplate.styled";
import { useNavigate, useParams } from "react-router-dom";
import { findModel } from "./MainTamplate.utils";
import { replacePolishChars } from "../../../view/slide-menu/SlideMenu.utils";
import { FilterContextProvider } from "../filter-context/FilterContextProvider";

const OrdersPage = React.lazy(() =>
  import("../../pages/order-page/OrdersPage").then((module) => ({
    default: module.OrdersPage,
  }))
);
const TasksPage = React.lazy(() =>
  import("../../pages/task-page/TasksPage").then((module) => ({
    default: module.TasksPage,
  }))
);

const VIEW_TYPE: { [key: string]: React.ComponentType<any> } = {
  forms_list: OrdersPage,
  tasks: TasksPage,
};

export const MainTemplate: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { name } = useParams();
  const models: any = queryClient.getQueryData(["/models"]);

  const { model, error } = useMemo(() => findModel(models, name), [
    models,
    name,
  ]);

  useEffect(() => {
    if (!name && !model && models?.length > 0) {
      navigate(
        `${replacePolishChars(models[0].name.toLowerCase().replace(/ /g, "-"))}`
      );
      return;
    }
  }, [name, model]);

  if (model) {
    const Component = VIEW_TYPE[model.subpage_type];

    if (!Component) {
      return (
        <Result
          status="404"
          title="BŁĄD"
          subTitle="Przepraszamy, wystąpił błąd. Skontaktuj się z administratorem"
          extra={<Button type="primary">Back Home</Button>}
        />
      );
    }

    return (
      <FilterContextProvider key={name}>
        <Suspense
          fallback={
            <MainTemplateLoading>
              <Spin size="large" />
            </MainTemplateLoading>
          }
        >
          <Component />
        </Suspense>
      </FilterContextProvider>
    );
  }

  if (error) {
    return (
      <Result
        status="403"
        title="BŁĄD"
        subTitle="Przepraszamy, wystąpił błąd. Skontaktuj się z administratorem"
        extra={<Button type="primary">Back Home</Button>}
      />
    );
  }

  if (!models || models.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: 32,
        }}
      >
        <Empty
          description={
            <Typography.Text type="secondary" style={{ fontSize: 16 }}>
              Brak istniejących modeli danych. Administrator musi je skonfigurować.
            </Typography.Text>
          }
        />
      </div>
    );
  }

  return (
    <MainTemplateLoading>
      <Spin size="large" />
    </MainTemplateLoading>
  );
};
